import { useProducts } from '../api/hooks/product';

export const DEFAULT_DEVICE_FEE_NAME = 'DaaS Device Fee';
export const useDeviceFee = () => {
  const [products] = useProducts();

  const deviceFeeProduct = products.find(p => p.name === DEFAULT_DEVICE_FEE_NAME);

  return deviceFeeProduct?.price?.price;
};
